// ThemeSelector.tsx
import React from 'react';
import { useTheme, ThemeType } from '../context/ThemeContext';
import styles from './ThemeSelector.module.css';
import { Palette } from 'lucide-react';

const ThemeSelector: React.FC = () => {
  const { theme, setTheme } = useTheme();

  const themes: { value: ThemeType; label: string; description: string }[] = [
    { 
      value: 'primary', 
      label: 'Sci-Fi Blue', 
      description: 'Clean blue sci-fi theme with glowing effects' 
    },
    { 
      value: 'dark', 
      label: 'Dark Mode', 
      description: 'Deep black theme with purple accents' 
    },
    { 
      value: 'light', 
      label: 'Light Mode', 
      description: 'Clean white theme for daytime use' 
    },
  ];

  return (
    <div className={styles.themeSelector}>
      <div className={styles.header}>
        <Palette className={styles.headerIcon} />
        <h3 className={styles.title}>Theme Preferences</h3>
      </div>
      <p className={styles.description}>
        Choose your preferred color theme for the website
      </p>

      <div className={styles.themeGrid}>
        {themes.map((themeOption) => (
          <button
            key={themeOption.value}
            className={`${styles.themeCard} ${theme === themeOption.value ? styles.active : ''}`}
            onClick={() => setTheme(themeOption.value)}
          >
            <div className={`${styles.themePreview} ${styles[themeOption.value]}`}>
              <div className={styles.previewHeader}></div>
              <div className={styles.previewSidebar}></div>
              <div className={styles.previewContent}>
                <div className={styles.previewBox}></div>
                <div className={styles.previewBox}></div>
              </div>
            </div>
            <div className={styles.themeInfo}>
              <h4 className={styles.themeName}>{themeOption.label}</h4>
              <p className={styles.themeDescription}>{themeOption.description}</p>
            </div>
            {theme === themeOption.value && (
              <div className={styles.activeIndicator}>
                <span>✓ Active</span>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;
